export const cssBundleHref = "/_static/build/css-bundle-VDFOIMP5.css";